import { sva } from "@stubhub/broadway-foundation/css";

export const aipBottomsheetRecipe = sva({
  slots: ["content", "iconContainer", "button", "detailBody", "row"],
  className: "aipBottomsheet",
  base: {
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      rowGap: "primitives.150",
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      borderStartStartRadius: "element.default",
      borderStartEndRadius: "element.default",
      borderEndEndRadius: "element.default",
      borderEndStartRadius: "element.default",
    },
    button: {
      width: "full",
    },
    detailBody: {
      display: "flex",
      flexDirection: "column",
      alignSelf: "stretch",
      rowGap: "primitives.300",
      marginBlockStart: "primitives.300",
      marginBlockEnd: "primitives.100",
      "& b": {
        fontWeight: "bold",
      },
    },
    row: {
      display: "flex",
      alignItems: "flex-start",
      columnGap: "primitives.200",
      textAlign: "start",
    },
  },
  variants: {
    placement: {
      title: {
        iconContainer: {
          width: "[56px]",
          height: "[56px]",
          backgroundColor: "bg.surface.brand",
        },
      },
      row: {
        iconContainer: {
          width: "primitives.500",
          height: "primitives.500",
          backgroundColor: "bg.surface.strong",
        },
      },
    },
    iconColor: {
      brand: {
        iconContainer: {
          color: "text.brand",
        },
      },
      info: {
        iconContainer: {
          color: "text.info",
        },
      },
    },
  },
  defaultVariants: {
    placement: "title",
    iconColor: "brand",
  },
});
